<span (mouseup)="moveEnd()">
  <img
    [src]="backgroundImage"
    #mapImage
    class="space-map__map-image"
    [style.cursor]="backgroundMoving ? 'move' : 'default'"
  />
  <div
    [ngClass]="{ 'ion-hide': !backgroundImage }"
    #mapContainer
    class="space-map__canvas"
    (wheel)="onWheel($event)"
    (mousedown)="onMoveBackground($event, 'mousemove')"
    (touchstart)="onMoveBackground($event, 'touchmove')"
    (touchend)="moveEnd()"
    [style.cursor]="backgroundMoving ? 'move' : 'default'"
    [style.height.px]="mapHeight"
    (mouseleave)="onDropSpace()"
  >
    <div class="space-map__cover" *ngIf="enableMovingSpace"></div>
    <div class="space-map__zoom-buttons-container">
      <ng-container *ngIf="!p.renderMobile">
        <ng-container *ngFor="let legendItem of popoverLegend">
          <div class="space-map__legend-container margin-right-16">
            <div
              class="space-map__space space-map__space--legend"
              [style.border-color]="legendItem.color"
              [style.color]="legendItem.color"
            >
              {{ legendItem.character }}
            </div>
            {{ legendItem.label | translate }}
          </div>
        </ng-container>
      </ng-container>

      <div class="display-flex ion-margin">
        <div
          class="space-map__zoom-button margin-right-4"
          (click)="onShowInfo($event)"
          *ngIf="p.renderMobile"
        >
          <img src="../../../../../assets/icons/info.svg" />
        </div>
        <div
          class="space-map__zoom-button margin-right-4"
          (click)="onButtonZoom(0.1)"
        >
          +
        </div>
        <div class="space-map__zoom-button" (click)="onButtonZoom(-0.1)">-</div>
      </div>
    </div>
    <div
      class="space-map__cover space-map__cover--alert"
      *ngIf="showScrollAlert && !p.renderMobile"
    >
      <p>{{ "SPACE_MAP.ZOOM_INFO" | translate }}</p>
    </div>
    <div
      #map
      class="space-map__map"
      [ngClass]="{ 'space-map__map--moving': enableMovingSpace }"
      [style.width.px]="mapWidth"
      [style.height.px]="mapHeight"
      [style.background-image]="
        backgroundImage ? 'url(' + backgroundImage + ')' : ''
      "
      [style.left.px]="backgroundPositionX"
      [style.top.px]="backgroundPositionY"
      [style.transform]="'scale(' + zoom + ')'"
      (dblclick)="onCreateNewPlace($event)"
      [style.cursor]="backgroundMoving ? 'move' : 'default'"
    >
      <div
        [style.height.px]="mapHeight"
        class="space-map__cover"
        *ngIf="enableMovingSpace"
      ></div>
      <ng-container *ngFor="let space of spaceList">
        <div
          *ngIf="space.posX && space.posY"
          class="space-map__space"
          (mouseup)="onDropSpaceAndSave(space)"
          (mousedown)="onGetSpacePosition(space)"
          [style.left.px]="space.posX"
          [style.top.px]="space.posY"
          [style.cursor]="
            !enableMovingSpace ? 'pointer' : spaceMoving ? 'grabbing' : 'grab'
          "
          (click)="onShowPopover($event, space)"
          (mousedown)="onSpaceToMove($event, space)"
          [ngClass]="spaceClass(space)"
        >
          {{ space.shortName ? space.shortName : space.name }}
        </div>
      </ng-container>
      <ng-container *ngFor="let space of temporarySpaceList">
        <div
          class="space-map__space space-map__space--unassigned"
          (mouseup)="onDropSpace()"
          [style.left.px]="space.posX"
          [style.top.px]="space.posY"
          [style.cursor]="
            !enableMovingSpace ? 'pointer' : spaceMoving ? 'grabbing' : 'grab'
          "
          (click)="onShowPopover($event, space)"
          (mousedown)="onSpaceToMove($event, space)"
        >
          ?
        </div>
      </ng-container>
    </div>
  </div>
  <div *ngIf="!backgroundImage" class="container space-map__no-result">
    <ion-icon
      class="space-map__no-result-icon"
      slot="start"
      name="map-outline"
    ></ion-icon>
    <p class="primary">
      {{ noResultInfoTranslationKey | translate }}
    </p>
  </div>
</span>
